<template>
  <DefaultPageContainer
    :cnc-ads-page="cncAdsPage"
    :breadcrumb-text="$t('newsroom.breadcrumbs')"
  >
    <section class="section">

      <!-- Current edition -->
      <div
        v-if="showSubscription"
        class="p-6 border-tertiary-700 border rounded-3xl mb-6"
      >
        <div class="sm:w-10/12 mx-auto flex flex-col sm:flex-row sm:items-center gap-6">
          <div class="max-w-28" v-if="getCurrentEditionImageSrc()">
            <NuxtLink :to="magazineSubscriptionLink" target="_blank">
              <!-- Dynamic image - get from article by currentEditionArticleId - loaded in layouts/default.vue-->
              <img class="w-full object-cover" loading="lazy" :src="getCurrentEditionImageSrc()" :alt="$t('header.current_edition')" width="300" height="400">
            </NuxtLink>
          </div>
          <div>
            <div class="text-lg font-bold">{{ $t('newsroom.current_edition-h') }}</div>
            <p>{{ $t('newsroom.current_edition-p') }}</p>
            <button class="btn btn--gradient mt-4">
              <NuxtLink :to="magazineSubscriptionLink" target="_blank">{{ $t('newsroom.current_edition-btn') }}</NuxtLink>
            </button>
          </div>
        </div>
      </div>
      <h1 class="h1" v-html="$t('newsroom.title')" />

      <!-- Content -->
      <div class="newsroom--perex"
         v-html="$t('newsroom.perex')"
      />

      <!-- Authors -->
      <div
        v-if="authors.length > 0"
        class="section__author-list"
      >
        <DefaultAuthorCard
          v-for="(author, index) in authors"
          :author="author"
          :is-big="index === 0 && authors.length > 3"
          :detail-url="getAuthorDetailPath(author)"
          class=""
        />
      </div>
    </section>
  </DefaultPageContainer>
</template>

<script setup lang="ts">
import {CncAdsPage} from "~/libs/constants/CncAdsPage"
import {useI18n} from "vue-i18n"
import type AuthorLocal from "~/libs/interfaces/AuthorLocal"
import {useHtmlToPlainText} from "~/composables/useHtmlToPlainText"
import {useArticlesStore} from "~/stores/useArticlesStore";
import {ArticleStoreType} from "~/libs/constants/ArticleStoreType";

// i18n routing
definePageMeta({
  name: 'newsroom',
})
false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    cs: '/redakce',
    en: '/newsroom'
  }
})

const config = useRuntimeConfig()
const route = useRoute()
const {t} = useI18n()
const cncAdsPage = CncAdsPage.NEWSROOM
const localePath = useLocalePath()

const authors = useRedactionConfig().getAuthorList()

const articleCurrentEditionStore = useArticlesStore(ArticleStoreType.CURRENT_EDITION)

// Set SEO meta
useSeoWrapper().setSeoMeta({
  title: useHtmlToPlainText(t('newsroom.title')),
})

const getAuthorDetailPath = (author: Partial<AuthorLocal>) => {
  return localePath({ name: 'newsroom-authorId', params: { authorId: author?.id } })
}

const showSubscription = config.public.showSubscription || false
const magazineSubscriptionLink = config.public.magazineSubscriptionLink

const getCurrentEditionImageSrc = () => {
  // return '/img/materidouska/nove-vydani-02-2025.png'
  return articleCurrentEditionStore.article?.previewAsset?.urlWithProtocol || null
}

/**
 * On mounted - load data client
 */
onMounted(async () => {
  /**
   * CncAds Page change
   */
  useCncAdsWrapper().changePageAds(cncAdsPage, {
    route: route
  })

})
</script>
